import React, { Component } from "react";
// react component for creating dynamic tables
import ReactTable from "react-table";
import {
    Row,
    Col,
    Grid,
    FormGroup,
    FormControl,
    ControlLabel,
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";

import Card from "../../components/Card/Card.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import * as submissionActions from '../../actions/submissionActions';
import rest from "../../API/api";
import ReactDOM from "react-dom";
import Datetime from "react-datetime";


class SubmissionReactTables extends Component {
    constructor(props) {
        super(props);
        //Lets call loadSubmissons and grab the submissions for this Tenant ONLY
        //Load 50 most recent records as default using an empty {} query json object
        this.props.submissionActions.loadSubmissions(this.props.userLoggedIn[0],"Tenant",{},"last50");
        //debugger;
        this._formatDate = this._formatDate.bind(this);
        this._load_rows = this._load_rows.bind(this);
        this._edit_submission = this._edit_submission.bind(this);
        this._delete_submission = this._delete_submission.bind(this);
        this._deleteSubmissionAlert = this._deleteSubmissionAlert.bind(this);
        this.handleQueryChange = this.handleQueryChange.bind(this);
        this.runQuery = this.runQuery.bind(this);
        this.state = {
            QueryType: "",
            QueryValue: "",
            QueryDate:"",
            QueryTypeError: null,
            QueryValueError: null,
            alert: null
        }

        //console.log(data.authenticated);
        //console.log(data.admin);
        //console.log('parsed json', data);
        //data.map(user => console.log(user.fname));
        //Check to see if the user authenticated
    }

    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }


    _deleteSubmissionAlert(id){
        //console.log("email to delete:" + email);
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes, delete it!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title="Are you sure?"
                    style={{display: "block"}}
                    onConfirm={() => this._delete_submission(id)}
                    onCancel={() => this.setState({alert: null})}
                >
                    Are you sure you want to delete this consent submission?
                </SweetAlert>
            )
        });
    }

    _edit_submission(id){
        //debugger;
        //Grab the current record from MongoDB and update the store via the reducer using the Thunk in submissionActions.js
        this.props.submissionActions.readSubmission(this.props.userLoggedIn[0],id);
    }
    _delete_submission(id){
        //console.log("email to delete:" + email);
        //lets call the customerActions.js thunk function to delete this customer record
        this.props.submissionActions.asyncAwaitDeleteSubmission(this.props.userLoggedIn[0],id,"Tenant");
        this.setState({alert: null});
        //call SweetAlerts and confirm that the customer was deleted successfully
    }

    _formatDate(dateString){
        //Convert the dateString to a date, reformat a temp string from it to mm/dd/yyyy
        var d = new Date(dateString),
            month_s = '' + (d.getMonth() + 1),
            day_s = '' + d.getDate(),
            year_s = d.getFullYear();

        if (month_s.length < 2)
            month_s = '0' + month_s;
        if (day_s.length < 2)
            day_s = '0' + day_s;

        var date_s = [month_s, day_s, year_s].join('/');
        return(date_s);
    }

    _load_rows(){
        this.state = {
            alert: null,
            data: this.props.submissions.map((submission,i) => {
                //Lets convert the date of birth stored to mm/dd/yyyy
                var dob_s = this._formatDate(submission.ConsentDOB);
                var dos_s = this._formatDate(submission.Date);
                return {
                    id: submission._id,
                    ConsentDate: dos_s,
                    ConsentName: submission.ConsentName,
                    ConsentDOB: dob_s,
                    ConsentArtist: submission.Artist,
                    ConsentFormName: submission.ConsentFormName,

                    actions: (
                        // we've added some custom button actions
                        <div className="actions-right">
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"display_" + i}>Display Submission</Tooltip>}>
                                <span>
                            <Button
                                onClick={ async () => {
                                    let obj = this.state.data.find(o => o.id === submission._id);
                                    //Open the form to edit the after we have updated the store with the customer
                                    //that we want to edit, this way the form can read the store and load the customer
                                    //record for editing from the Redux Store
                                    let tURL = "/displaysubmissionform/" + obj.id;
                                    await this.context.router.history.push(tURL);
                                }}
                                bsStyle="info"
                                simple
                                icon
                            >
                                <i className="fa fa-desktop "/>
                            </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"delete_" + i}>Delete Submission</Tooltip>}>
                                <span>
                            <Button
                                onClick={() => {
                                    var data = this.state.data;
                                    data.find((o, i) => {
                                        if (o.id === submission._id) {
                                            //pass the id to delete to handler so it can be passed to
                                            //tenantActions.js thunk for store update
                                            this._deleteSubmissionAlert(o.id);
                                            return true;
                                        }
                                        return false;
                                    });
                                    this.setState({data: data});
                                }}
                                bsStyle="danger"
                                simple
                                icon
                            >
                                <i className="fa fa-times"/>
                            </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {this.state.alert}
                        </div>
                    )
                };
            })
        };
    }

    handleQueryChange= () => {
        //console.log(ReactDOM.findDOMNode(this.select).value);
        this.setState({
            QueryType: ReactDOM.findDOMNode(this.selectQuery).value,
            QueryValue: ""
        });
    };

    basicAlert(message_s)  {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Query Error!"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="info"
                >
                    {message_s}
                </SweetAlert>
            )
        });
    }
    hideAlert() {
        this.setState({
            alert: null
        });
    }

    runQuery(event){
        event.preventDefault();
        //Lets do some error checking to be sure the values are set correctly for the query type
        var query,queryType,dob_s,date_s,value=false,type=false,valid=false,date_start,date_end,querydate_s;
        var dob_ex = /(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/;
        var type_s = ReactDOM.findDOMNode(this.selectQuery).value;
        //use the react datetime component and access its state directly....works better than this.state because
        //react table render clears all states...
        querydate_s = this.dateQuery.state.inputValue;
        var value_s = document.getElementById('QueryValue').value;
        if((type_s === "") || (type_s === "Query Type?"))
            window.alert("Query Error\nPlease provide a Query Type before you run a query!");
        type = ((type_s !== "") && (type_s !== "Query Type?"));

        switch(ReactDOM.findDOMNode(this.selectQuery).value){
            case "Last 50 Submissions":
                query = {};
                queryType = "last50";
                value = true;
                break;
            case "Consent Name":
                if(value_s === "")
                    window.alert("Query Error\nPlease provide a consent's name.");
                value = value_s !== "";
                query = {ConsentName: value_s};
                queryType = "consentName";
                break;
            case "Consent Date of Birth":
                //convert date of birth to ISO format
                if(!dob_ex.test(querydate_s)) {
                    window.alert("Query Error\nConsent's DOB must be formatted as MM/DD/YYYY");
                }
                else
                    dob_s = new Date(querydate_s);
                value = querydate_s !== "";
                value = ((querydate_s !== "") && dob_ex.test(querydate_s));
                query = {ConsentDOB: dob_s};
                queryType = "consentDOB";
                break;
            case "Artist Name":
                if(value_s === "")
                    window.alert("Query Error\nPlease provide an artist name.");
                value = value_s !== "";
                query = {Artist: value_s};
                queryType = "artistName";
                break;
            case "Last 24hrs":
                //get todays date and then set it to 00:00 and 23:59 time wise
                var d = new Date(),
                month_s = '' + (d.getMonth() + 1),
                day_s = '' + d.getDate(),
                year_s = d.getFullYear();

                if (month_s.length < 2)
                    month_s = '0' + month_s;
                if (day_s.length < 2)
                    day_s = '0' + day_s;

                date_start = [year_s, month_s, day_s].join('-') + "T00:00:00.000Z";
                date_end = [year_s, month_s, day_s].join('-') + "T23:59:59.999Z";
                query = {startdate: date_start, enddate:date_end};
                queryType = "dateRange";
                value=true;
                break;
            case "Specific Date":
                //get specific date and then set it to 00:00 and 23:59 time wise
                if(!dob_ex.test(querydate_s)) {
                    window.alert("Query Error\nSpecific Date must be formatted as MM/DD/YYYY");
                }
                else {
                    date_s = new Date(querydate_s);
                    month_s = '' + (date_s.getMonth() + 1);
                    day_s = '' + date_s.getDate();
                    year_s = date_s.getFullYear();

                    if (month_s.length < 2)
                        month_s = '0' + month_s;
                    if (day_s.length < 2)
                        day_s = '0' + day_s;

                    date_start = [year_s, month_s, day_s].join('-') + "T00:00:00.000Z";
                    date_end = [year_s, month_s, day_s].join('-') + "T23:59:59.999Z";
                    query = {startdate: date_start, enddate:date_end};
                    queryType = "dateRange";
                }
                value = querydate_s !== "";
                value = ((querydate_s !== "") && dob_ex.test(querydate_s));
                break;
            default:

        }
        valid = type && value;
        if(valid) {
            this.props.submissionActions.loadSubmissions(this.props.userLoggedIn[0], "Tenant", query,queryType);
            this._load_rows();
        }
    };


    render() {
        //debugger;
        //console.log(this.props.customer);
        this._load_rows();
        if ((this.props.userLoggedIn[0].role === "User") || (this.props.userLoggedIn[0].role === "Admin")) {
            return (
                <div className="main-content" style={{ backgroundImage: "url(" + require("../../assets/img/matrix.jpg") + ")" }}>
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Card
                                    content={
                                        <div>
                                            <legend>Search Criteria</legend>
                                            <Row>
                                                <Col md={3} mdOffset={1}>
                                                    <FormGroup>
                                                        <ControlLabel>Select your search criteria? <span className="text-danger">*</span></ControlLabel>
                                                        <FormControl componentClass="select"
                                                                     placeholder="Query Type?"
                                                                     ref={select => { this.selectQuery= select }}
                                                                     onChange={this.handleQueryChange}
                                                                     value={this.state.QueryType}
                                                        >
                                                            <option value="Query Type?">Query Type?</option>
                                                            <option value="Last 50 Submissions">Last 50 Submissions</option>
                                                            <option value="Last 24hrs">Last 24hrs</option>
                                                            <option value="Specific Date">Specific Date</option>
                                                            <option value="Consent Name">Consent Name</option>
                                                            <option value="Consent Date of Birth">Consent Date of Birth</option>
                                                            <option value="Artist Name">Artist Name</option>
                                                        </FormControl>
                                                        {this.state.QueryTypeError}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3} >
                                                    <FormGroup>
                                                        <ControlLabel>Consent / Artist Name Value <span className="text-danger">*</span></ControlLabel>
                                                        <FormControl
                                                            id="QueryValue"
                                                            type="text"
                                                            name="QueryValue"
                                                            placeholder="Enter the value to query for"
                                                            value={this.state.QueryValue}
                                                            onChange={event => this.setState({QueryValue: event.target.value})}
                                                        />
                                                        {this.state.QueryValueError}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                    <FormGroup>
                                                        <ControlLabel>Specific Date or Consent DOB <span className="text-danger">*</span> </ControlLabel>
                                                        <Datetime
                                                            id="QueryDate"
                                                            timeFormat={false}
                                                            ref={datetime => { this.dateQuery= datetime }}
                                                            inputProps={{placeholder: "Choose your specific date or Consent's DOB"}}
                                                            value={this.state.QueryDate}
                                                            //onChange={this.handleChange}
                                                            onChange={value => this.setState({ QueryDate: value })}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={3}  mdOffset={1} xs={3} xsOffset={1}>
                                                    <Button bsStyle="info" fill wd onClick={this.runQuery}>
                                                        Run Query
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Card
                                    title="Our Submissions"
                                    content={
                                        <ReactTable
                                            data={this.state.data}
                                            filterable
                                            columns={[
                                                {
                                                    Header: "Date",
                                                    accessor: "ConsentDate"
                                                },
                                                {
                                                    Header: "Name",
                                                    accessor: "ConsentName"
                                                },
                                                {
                                                    Header: "Date of Birth",
                                                    accessor: "ConsentDOB"
                                                },
                                                {
                                                    Header: "Artist",
                                                    accessor: "ConsentArtist"
                                                },
                                                {
                                                    Header: "Consent Form",
                                                    accessor: "ConsentFormName"
                                                },
                                                {
                                                    Header: "Actions",
                                                    accessor: "actions",
                                                    sortable: false,
                                                    filterable: false
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            showPaginationTop
                                            showPaginationBottom={true}
                                            defaultSortDesc={true}
                                            defaultSorted={[{ // the sorting model for the table
                                                id: 'ConsentDate',
                                                desc: true
                                            }]}
                                            className="-striped -highlight"
                                        />
                                    }
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
            )

        }
        else {
            this.context.router.history.push("/pages/login-page");
            return(null);
        }

    }
}



SubmissionReactTables.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
    submissions: PropTypes.array.isRequired,
    submission: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    //debugger;
    return {
        userLoggedIn: state.userLoggedIn,
        submissions: state.submissions,
        submission: state.submission
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        submissionActions: bindActionCreators(submissionActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionReactTables);

//export default ReactTables;



// WEBPACK FOOTER //
// ./src/views/Tables/SubmissionsTable.jsx